import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";

import Picture from "../Common/Picture";
import EllipsedText from "../Common/EllipsedText";

import {
  CONTEXT,
  CONTEXT_LPR,
  CONTEXT_OCR,
  OCR,
  LPR,
  FR,
  FACE_DETECT,
  HUMAN_DETECT,
  HUMAN_EXIT,
} from "../../constants/common";
import { getAttributeValue } from "../../utils/profile";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const styles = {
  container: {
    textAlign: "center",
    margin: "0px 5px",
    width: "84px",
  },
  type: {
    color: colors.black54,
    fontSize: "0.9em",
    lineHeight: "1.0",
    paddingBottom: "4px",
    height: "28px",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
  },
  picture: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "auto",
  },
};

const CapturedPhoto = (props) => {
  const { classes, onClickPhoto, roiOverlay } = props;

  let latestValue;
  if (get(props, ["lastEvent", "attributes"])) {
    latestValue = props.lastEvent.attributes.filter((attr) => attr.id === 140);
    if (latestValue.length > 0) {
      latestValue = latestValue[0].value;
    } else {
      latestValue = null;
    }
  }
  if ([76, 78].includes(get(props, ["lastEvent", "type", "id"]))) {
    latestValue = "confirmed";
  }

  return (
    <Grid item className={classes.container}>
      <Grid container direction="column">
        <Grid item className={classes.type}>
          {props.type && props.type !== FR && (
            <>
              {latestValue && (
                <span style={{ color: colors.green, marginRight: "5px" }}>
                  {latestValue === 84 ? OCR : latestValue === 85 ? LPR : ""}
                </span>
              )}
              <span
                style={{
                  textDecoration:
                    latestValue && latestValue !== "confirmed"
                      ? "line-through"
                      : "",
                  color: latestValue === "confirmed" ? colors.green : "",
                }}
              >
                {I18n.get("site_" + props.type.toLowerCase())}
              </span>
            </>
          )}
        </Grid>
        <Grid
          item
          className={classes.picture}
          style={{
            outline: props.selected
              ? `${colors.selectedOrange} 2px solid`
              : "none",
            border: props.selected
              ? `1px solid ${colors.selectedOrange}`
              : `1px solid ${colors.veryLighPink}`,
            width: "72px",
            height: "72px",
            borderRadius: props.selected ? "0px" : "1px",
            cursor: onClickPhoto ? "pointer" : "initial",
            position: "relative",
          }}
          onClick={() => {
            if (onClickPhoto) onClickPhoto(props.photo);
          }}
        >
          <Picture
            noZoom={onClickPhoto || props.noZoom ? true : false}
            url={props.img}
            alt={"cropped_photo"}
            maxHeight={70}
            style={{
              maxWidth: "70px",
              maxHeight: "70px",
              borderRadius: "2px",
            }}
            roiOverlay={roiOverlay}
          />
          {props.matched && (
            <img
              src={images.greenCheckmarkWhite}
              alt="check_circle"
              width="16px"
              style={{
                position: "absolute",
                bottom: "-7px",
                right: "-2px",
              }}
            />
          )}
        </Grid>
        {props.lastEvent &&
        [75, 77].includes(props.lastEvent.type.id) &&
        getAttributeValue(
          props.lastEvent,
          props.lastEvent.type.id === 75 ? 50 : 44
        ) ? (
          <>
            <Grid item style={{ color: colors.green, paddingTop: "5px" }}>
              <EllipsedText
                text={getAttributeValue(
                  props.lastEvent,
                  props.type === "OCR" ? 50 : 44
                )}
                maxLength={8}
              />
            </Grid>
            {props.values.map((text, index) => (
              <Grid
                item
                key={text + index}
                className="text-54"
                style={{
                  textDecoration: "line-through",
                }}
              >
                <EllipsedText text={text} maxLength={8} />
              </Grid>
            ))}
          </>
        ) : (
          props.values.map((text, index) => (
            <Grid
              item
              key={text + index}
              style={{
                paddingTop: "5px",
                color: props.lastEvent ? colors.green : colors.black87,
              }}
            >
              <EllipsedText text={text} maxLength={8} />
            </Grid>
          ))
        )}
      </Grid>
    </Grid>
  );
};

CapturedPhoto.propTypes = {
  type: PropTypes.oneOf([
    CONTEXT,
    CONTEXT_LPR,
    CONTEXT_OCR,
    OCR,
    LPR,
    FR,
    FACE_DETECT,
    HUMAN_DETECT,
    HUMAN_EXIT,
  ]).isRequired,
  img: PropTypes.string,
  values: PropTypes.array.isRequired,
  matched: PropTypes.bool,
  onClickPhoto: PropTypes.func,
};

export default withStyles(styles)(CapturedPhoto);
